import React, { useState } from "react";
import { Tabs } from "../../_styleguide";
import { IconReport } from "@tabler/icons-react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Header, Text } from "@centrate-io/barn";
import "./ExceptionReportingWorkflow.scss";

function ExceptionReportingWorkflow(props) {
    const navigate = useNavigate();
    const params = useParams();
    const [tab, setTab] = useState(params?.tab) || "sample-tab";
    const deal_id = params.id;
  
    let items = [
      {
        key: "sample-tab",
        label: (
          <div className="tab-name">
            <IconReport />
            Sample Tab 1
          </div>
        ),
        children: <></>,
      },
      {
        key: "sample-tab-2",
        label: (
          <div className="tab-name">
            <IconReport />
            Sample Tab 2
          </div>
        ),
        children: <></>,
      },
      {
        key: "sample-tab-3",
        label: (
          <div className="tab-name">
            <IconReport />
            Sample Tab 3
          </div>
        ),
        children: <></>,
      }
    ];
  
    return (
      <div className="admin-tabs app-exception-report">
        <div className="admin-header">
          <div className="crumbs" >
            <Header type="display" size="5">
              Exception Reporting Workflow
            </Header>
          </div>
        </div>
        <Tabs
          onChange={(key) => {
            navigate(`/deal/${deal_id}/exception-reporting/${key}`);
            setTab(key);
          }}
          activeKey={tab}
          items={items}
          className={tab}
          destroyInactiveTabPane={true}
        />
      </div>
    );
  }
  
  export default ExceptionReportingWorkflow;